import React, { useId } from "react";
import { t } from "ttag";

import { NewsletterSignupBlock } from "@reactivated";

import { CRMForm, FormType } from "../CRMForm";
import { WhoAreYouSelect } from "../CRMForm/WhoAreYouSelect";
import { ButtonPrimary } from "../Clickables";
import { TextField } from "../Forms/Input";
import { RichText } from "../RichText";

import styles from "./NewsletterSignup.module.scss";

export const NewsletterSignup = (props: { value: NewsletterSignupBlock }) => {
    const headingId = useId();

    return (
        <div className={styles.root}>
            <div className={styles.text}>
                <h2 id={headingId} className={styles.heading}>
                    {props.value.heading}
                </h2>
                {props.value.description && (
                    <RichText
                        value={props.value.description}
                        className={styles.description}
                    />
                )}
            </div>
            <div
                className={styles.form}
                role="form"
                aria-labelledby={headingId}
            >
                <CRMForm
                    type={FormType.STAY_INFORMED}
                    custom_submit_url={props.value.custom_submit_url ?? null}
                    layout="full-width"
                >
                    {(disabled, legal) => (
                        <>
                            <div className={styles.fields}>
                                <TextField
                                    label={t`Email`}
                                    name="email_address"
                                    type="email"
                                    isRequired
                                    placeholder={t`Enter your email address`}
                                    className={styles.field}
                                />
                                <TextField
                                    label={t`ZIP Code`}
                                    name="zip_code"
                                    isRequired
                                    placeholder={t`Enter your zip code`}
                                    className={styles.field}
                                />
                                <WhoAreYouSelect
                                    label={t`Which Describes You Best`}
                                    placeholder={t`Select one`}
                                    className={styles.fieldFullWidth}
                                />
                            </div>
                            {legal}
                            <ButtonPrimary
                                type="submit"
                                disabled={disabled}
                                className={styles.submit}
                            >
                                {t`Submit`}
                            </ButtonPrimary>
                        </>
                    )}
                </CRMForm>
            </div>
        </div>
    );
};
